import * as React from 'react';
import { connect } from 'react-redux';
import KPClaimList from '../../SSPCustomComponentLibrary/KPClaimList/KPClaimList';
import { ILossType, IClaimListItem } from '../../../../interfaces/KPClaimList/KPClaimListInterfaces';
import { IDropdownData } from '../../../../interfaces/KPDropdown/KPDropdownInterfaces';
import '../../StylingProjectMain.css';
import { CONTENT_CLAIM_TYPE_ID } from '../../../../constants/constants';

class KPClaimListPage extends React.Component<any, any> {
    claimListComponent: React.RefObject<KPClaimList>;

    constructor(props) {
        super(props);

        this.state = {
            claimCount: 3,
            lossTypes: [],
            lossItems: [],
            result: ""
        };

        this.claimListComponent = React.createRef();
        this.handleNext = this.handleNext.bind(this);
    }

    componentDidMount() {
        let lossTypes = this.getLossTypes();
        let lossItems = this.getLossItems(lossTypes);
        this.setState({ lossTypes, lossItems });

        if (this.claimListComponent?.current != null) {
            this.claimListComponent.current.setList(lossItems);
            this.claimListComponent.current.setLossTypes(lossTypes);
        }
    }

    getLossItems(lossTypes: ILossType[]): IClaimListItem[] {
        let dataSet: IClaimListItem[] = [];
        for (let i = 0; i < this.state.claimCount; i++) {
            let lossType = i < lossTypes.length ? lossTypes[i] : lossTypes[0];
            dataSet.push({
                id: i.toString(),
                index: i,
                date: new Date("2023-01-0" + (i + 1).toString() + "T00:00:00"),
                lossType: { id: lossType.id, description: lossType.description, productName: lossType.description, image: "" } as IDropdownData,
                value: (i + i * i),
                isExisting: false,
                claimType: CONTENT_CLAIM_TYPE_ID,
                currentPremises: false,
            });
        }
        return dataSet;
    }

    getLossTypes(): ILossType[] {
        let lossTypes: ILossType[] = [];
        for (let i = 1; i <= 5; i++) {
            lossTypes.push({
                id: i.toString(),
                description: "Type-" + i.toString()
            });
        }
        return lossTypes;
    }

    handleNext() {
        if (this.claimListComponent?.current !== null) {
            this.claimListComponent.current.validate();
            let claims = this.claimListComponent.current.getList();
            let result = "<div>Result:</div>";
            claims.forEach(claim => {
                result += "<div class='row'>";
                result += "<div class='col-md-3'>" + claim.index + "</div>";
                result += "<div class='col-md-3'>" + claim.date?.toString() + "</div>";
                result += "<div class='col-md-3'>" + claim.lossType?.description + "</div>";
                result += "<div class='col-md-3'>" + claim.value + "</div>";
                result += "</div>";
            });
            this.setState({ result });
        }
    }

    render() {
        return (
            <div id="appContainer" className="noProfile styling-project" style={{paddingBottom:"100px"}}>
                <div className="styling-foundation-page-header">
                    SSP KP Claim List Component
                </div>

                <div className="styling-foundation-input-container-large mt-4" style={{ width: "unset" }}>
                    <div className="row">
                        <div className="col-md-10 col-lg-8">
                            <KPClaimList
                                ref={this.claimListComponent}
                                initialCount={this.state.claimCount}
                                items={this.state.lossItems}
                                currencySymbol={this.props.profile.currencySymbol + " "}
                                claimType={CONTENT_CLAIM_TYPE_ID}
                            />
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12 justify-content-center" style={{ display: "flex" }}>
                            <button id="btnClaimListNext" className="btn btn-solid-red btn-responsive" onClick={this.handleNext}>Next</button>
                         </div>
                    </div>

                    <div className="row">
                        <div className="col-md-10 col-lg-8" dangerouslySetInnerHTML={{ __html: this.state.result }}>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(KPClaimListPage)